import apiZervant from '../../utils/apiZervant'
import { CompanyOnboarding } from './types/companyOnboarding'

interface CompanyOnboardingResponse {
  onboarding: CompanyOnboarding
}

export const fetchCompanyOnboarding = async () => {
  return apiZervant.platform.get<CompanyOnboardingResponse>('/v4/company')
}

export type UpdateCompanyOnboardingPayload = Partial<CompanyOnboarding>

export const updateCompanyOnboarding = async (payload: UpdateCompanyOnboardingPayload) => {
  return apiZervant.platform.patch<CompanyOnboardingResponse>('/v4/company', { onboarding: payload })
}
